import $ from 'jquery';
window.$ = window.jQuery = $;

/*document.querySelector('.chat[data-chat=person2]').classList.add('active-chat');*/


let friends = {
  list: document.querySelector('ul.people'),
  all: document.querySelectorAll('.left .person'),
  name: '' },

chat = {
  container: document.querySelector('.container .right'),
  current: null,
  person: null,
  name: document.querySelector('.container .right .top .name') };


friends.all.forEach(f => {
  f.addEventListener('mousedown', () => {
    f.classList.contains('active') || setAciveChat(f);
  });
});

function setAciveChat(f) {
  friends.list.querySelector('.active').classList.remove('active');
  f.classList.add('active');
  chat.current = chat.container.querySelector('.active-chat');
  chat.person = f.getAttribute('data-chat');
  chat.current.classList.remove('active-chat');
  chat.container.querySelector('[data-chat="' + chat.person + '"]').classList.add('active-chat');
  friends.name = f.querySelector('.name').innerText;
  chat.name.innerHTML = friends.name;
}
//inventor pop-up
$(document).on("click", ".workstreammessage", function()
{
    let id = $(this).data('id');
    $.ajax(
    {
        url:  '/workstream/message/' + id,
        type: 'GET',
        dataType: 'json',
        success: function(response) 
        {
            let qstatus = '';
            let i = 0;
            let p = 0;
            let j = 0;
            let work = response['work'];
            let status = response['status'];
            let stageCategory = response['stageCategory'];
            let stageName = null;
            let stageID = null;
            if(stageCategory != null)
            {
                 stageName = stageCategory.stageName;
                 stageID = stageCategory.stage_id;
            }
            let quote = response['quote'];
            let qdata = response['qdata'];
            //alert(qdata.quote_id);
            let quotelist = response['quotelist'];
            let quotelinelist = response['quotelinelist'];
            let ewid = response['ewid'];
            let quotefile = response['quotefile'];
            //alert(quotefile.length);
            let qturl =  "/inventor-quote/" + ewid;
            let quotetable = "";
            if (quote.length > 0) 
            {
                for (i = 0; i < quotelist.length; i++) 
                {
                    let now = quotelinelist[i].updated_at;
                    let date1 = new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date = date1[0] + ', ' + date1[1] + ' ' + date1[2] + ', ' + date1[3];
                    let time = now.substr(11, 5);
                    quotetable += '<h1>Quote Reference: ' + quotelist[i].quoteRef_id + '</h1><b><center>Time: ' + time + '</center></b>';
                    quotetable += '<table id="qid" border="2" style="float:right;width: 36%;"><tr><th>Date</th><td>' + date + '</td></tr>';
                    if (quotelist[i].quoteRef_id != null) 
                    {
                        /*quotetable +='<tr><th>QuoteRef</th><td>'+quotelist[i].quoteRef_id+'</td></tr></table>';*/
                    } 
                    else 
                    {
                        quotetable += '</table>'
                    }
                    quotetable += '<table id="qitm"><tr><th>Item</th><th>Rate</th><th>Quantity</th><th>Tax %</th><th>Price</th></tr>';
                    for (j = 0; j < quotelinelist.length; j++) 
                    {
                        if (quotelinelist[j].quote_id == quotelist[i].quote_id) 
                        {
                            quotetable += '<tr><td>' +
                                quotelinelist[j].item +
                                '</td><td>$' +
                                +quotelinelist[j].rate +
                                '</td><td>' +
                                +quotelinelist[j].quantity +
                                '</td><td>' +
                                +quotelinelist[j].tax +
                                '</td><td>$' +
                                +quotelinelist[j].price +
                                '</td></tr>';
                        }
                    }
                    quotetable += '</table>';
                    quotetable += '<table id="qid" border="2" style="float:right;width: 50%;">';
                    if (quotelist[i].extra != null) 
                    {
                        quotetable += '<tr><th>Extra</th><td style="width: 58%;">$' + quotelist[i].extra + '</td></tr>';
                    }
                    if (quotelist[i].discount != null) 
                    {
                        quotetable += '<tr><th>Discount</th><td style="width: 58%;">$' + quotelist[i].discount + '</td></tr>';
                    }
                    quotetable += '<tr><th>Total Amount</th><td style="width: 58%;">$' + quotelist[i].finalprice + '</td></tr></table><br>';
                    quotetable += '<a href="' + qturl + '" class="sign " target="blank">Quote Details</a>';
                    if (quotelist[i].quote_status == 'Submited') 
                    {
                        qstatus = "Received";
                    } 
                    else 
                    {
                        qstatus = quotelist[i].quote_status;

                    }
                    quotetable += '<select data-current="' + quotelist[i].quote_status + '" style="height:40px" name="quotestatus" id="quotestatus" selected onchange="quotestatus(' + quotelist[i].quote_id + ');" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '"><option value="' + qstatus + '">' + qstatus + '</option>';
                    if (quotelist[i].quote_status == 'Submited') 
                    {
                        quotetable += '<option data-current="' + quotelist[i].quote_status + '" value="Shortlisted" class="quotestatus"  data-id="Shortlisted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Shortlist</option><option value="Accepted" class="quotestatus"  data-id="Accept" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Accept</option><option value="Rejected" data-id="Reject" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Reject</option></select><br>';

                    } 
                    else if (quotelist[i].quote_status == 'Accepted') 
                    {
                        quotetable += '<option value="Shortlisted" data-current="' + quotelist[i].quote_status + '" class="quotestatus"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Shortlisted">Shortlist</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Rejected"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Rejected">Reject</option></select><br>';

                    } 
                    else if (quotelist[i].quote_status == 'Shortlisted') 
                    {
                        quotetable += '<option value="Rejected" data-current="' + quotelist[i].quote_status + '" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Rejected">Reject</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Accepted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Accepted">Accept</option></select><br>';

                    } 
                    else 
                    {
                        quotetable += '<option value="Shortlisted" data-current="' + quotelist[i].quote_status + '" class="quotestatus"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Shortlisted">Shortlist</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Accepted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Accepted">Accept</option></select><br>';
                    }

                    if (quotelist[i].quote_status == 'Submited') 
                    {
                        qstatus = "Received";
                    } 
                    else 
                    {
                        qstatus = quotelist[i].quote_status;

                    }
                    $('#pqid').val(quotelist[i].quote_id);
                    $('#pfinalprice').val(quotelist[i].finalprice);
                    $('#cstatus').val(quotelist[i].quote_status);
                }
                if (quotefile.length > 0) 
                {
                    quotetable += '<br><br><b>Attachment</b>'
                    for (i = 0; i < quotefile.length; i++) 
                    {
                        let furl =  "/quote/donwloadfile/" + quotefile[i].quoteFile_id;
                        quotetable += '<a href="' + furl + '" target="_blank"><br>' + quotefile[i].fileName + '</a>';
                    }
                }
                $("#nolink").addClass("d-none");
                $("#nolink").removeClass("d-block");
                $("#nolink").removeClass("d-block");
                $(".quote-list").addClass("d-block");
                $(".quote-list").removeClass("d-none");
                let url = "/viewquote/" + response['workid'];
                $("#linkquote").attr("href", url);

            } 
            else 
            {
                $("#qlink").addClass("d-none");
                $("#qlink").removeClass("d-block");
                $("#nolink").addClass("d-block");
                $("#qlink").removeClass("d-block");
                $("#nolink").removeClass("d-none");
            }
            if (status.workstreamStatus == 1) 
            {

                $("#workclose").addClass("d-none");
                $("#workopen").addClass("d-block");
                $("#workclose").removeClass("d-block");
                $("#workopen").removeClass("d-none");
                $("#write").addClass("d-none");
                $("#write").removeClass("d-block");
                $("#workstatus").addClass("d-block");
                $("#workstatus").removeClass("d-none");
            } 
            else 
            {
                $("#write").addClass("d-block");
                $("#write").removeClass("d-none");
                $("#workclose").addClass("d-block");
                $("#workopen").addClass("d-none");
                $("#workclose").removeClass("d-none");
                $("#workopen").removeClass("d-block");
                $("#workstatus").addClass("d-none");
                $("#workstatus").removeClass("d-block");
            }
            let receiver = response['receiver'];
            let messages = response['messages'];
            let name = receiver.name;
            let tags = [];
            if (response['rt'].length > 0) 
            {
                $("#rating-widget").remove();
                $("#rating-stars").remove();
                for (i = 0; i < response['tags'].length; i++) 
                {
                    tags += response['tags'][i].tag + ',';
                }
                let rs = receiver.stars * 20;
                let stars = $("#stars li").parent().children('li.star');
                for (i = 0; i < receiver.stars; i++) 
                {
                    $(stars[i]).addClass('star hover selected');
                }
                $('#stars').val(receiver.stars);
                $(document).ready(function() 
                {
                    $("#stars li").load(function() 
                    {

                    });
                });
                $('#rating_id').val(receiver.rating_id);
                $('#stars').val(receiver.stars);
                $('#reviewComments').val(receiver.comments);
            }
            $('.subject').val(receiver.subject);
            $('#vendors').val(receiver.id);
            $('#feedbackVendorId').val(receiver.id);
            $('#emails').val(receiver.email);
            let msg = "";
            let inventor = [];
            for (i = 0; i < messages.length; i++) 
            {
                $('#workstreamId').val(messages[i].wid);
                $('#feedbackWorkId').val(messages[i].wid);
                if (messages[i].Sender_id == response['flag']) 
                {
                    if (messages[i].quote_status == 1) 
                    {
                        $("#workquotestatusb").addClass("d-block");
                        $("#workquotestatusb").removeClass("d-none");
                        let url = "/viewquote/" + response['workid'];
                        $("#workquotestatus").attr("href", url);
                    } 
                    else 
                    {
                        $("#workquotestatusb").addClass("d-none");
                        $("#workquotestatusb").removeClass("d-block");
                    }
                    let now = messages[i].updated_at;
                    let date1 = new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date = date1[0] + ', ' + date1[1] + ' ' + date1[2] + ', ' + date1[3];
                    let time = now.substr(11, 5);
                    let file = messages[i].messagefiles;
                    msg += '<div class="conversation-start"></div>';

                    if (messages[i].message != null) 
                    {
                        msg += '<div class="bubble me inventor">' +
                            messages[i].message + '<br>';
                    } 
                    else 
                    {
                        msg += '<div class="bubble me inventor">';
                    }
                    if (messages[i].messagefiles.length != 0) 
                    {
                        msg += '<br>';
                        for (p = 0; p < messages[i].messagefiles.length; p++) 
                        {
                            let url =  '/donwload-file/' + messages[i].messagefiles[p].id;
                            msg += '<a href="' + url + '"><span class="attachlink"></span><i>' + messages[i].messagefiles[p].fileName + '</i></a><br>';
                        }
                        msg += '<span class="timestamp">' + date + time + '</span></div>';
                    } 
                    else 
                    {
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>'
                    }

                } 
                else 
                {
                    let now = messages[i].updated_at;
                    let date1 = new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date = date1[0] + ', ' + date1[1] + ' ' + date1[2] + ', ' + date1[3];
                    let time = now.substr(11, 5);
                    if (messages[i].message != null) {
                        msg += '<div class="bubble you vendor">' +
                            messages[i].message + '<br>';
                    } 
                    else {
                        msg += '<div class="bubble you vendor">';
                    }
                    if (messages[i].messagefiles.length != 0) {
                        msg += '<br>';
                        for (p = 0; p < messages[i].messagefiles.length; p++) {
                            let url =  '/donwload-file/' + messages[i].messagefiles[p].id;
                            msg += '<a href="' + url + '"><span class="attachlink"></span><i>' + messages[i].messagefiles[p].fileName + '</a><br>';
                        }
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';

                    } 
                    else {
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>'
                    }
                }
                msg += "</div>";
                let title = getWorkstreamHeader(receiver.subject,receiver.companyName,stageName,receiver.name,receiver.wid);
                let sub = '<h6><b>' + receiver.subject + '</b></h6>';
                $('.subject').html(sub);
                $('.modal-title').html(title);

                //$('.conversation-start').html(date);
                $('.chat').html(msg);
                $('.quote-list').html(quotetable);
                $('#messageModal').modal("show");       
                $('#overlay').fadeOut("300");
                

            }
        }
    });
});


//Feedback
$(document).on("click", ".fedbacksubmit", function()
{
    //alert("done");
    let star = $('#stars').val();
    let reviewComments = $('#reviewComments').val();
    let tags = $('#review-tags').val();
    //alert(star);
    //alert(tags);
    //alert(reviewComments);
    if(reviewComments != "" && reviewComments != "" && reviewComments != "")
    {
        $('.feedbackform').submit();

    }
    else
    {
        alert("fill all details ");
    }

});

$(document).on("click", ".feedback", function()
{
    let id = $(this).data('id');
    $('.active').removeClass('active');
    $("#feed").addClass('active');
    $.ajax(
    {
        url:  '/workstream/message/' + id,
        type: 'GET',
        dataType: 'json',
        success: function(response)
        {
            let stageCategory = response['stageCategory'];
            let stageName = null;
            let stageID = null;
            if(stageCategory != null)
            {
                 stageName = stageCategory.stageName;
                 stageID = stageCategory.stage_id;
            }
            let receiver = response['receiver'];
            let rtd = response['rtd'];
            let unapprovedata = response['undata'];
            let untags = response['untags'];
            let messages = response['messages'];
            let name = receiver.name;
            let tags = [];
            let i = 0;
            let tagid = '';
            if (response['rt'].length > 0)
            {
                if (unapprovedata != null)
                {
                    $("#rating-widget").remove();
                    $("#rating-stars").remove();
                    if (untags.length > 0)
                    {
                        for (i = 0; i < untags.length; i++)
                        {
                           let tags = untags[i].tagName;
                            tagid = untags[i].ratingTag_id;
                            $('#review-tags').append('<option value="' + tagid + '" selected>' + tags + '</option>');
                        }
                    }
                    let rs = unapprovedata.stars * 20;
                    let stars = $("#stars li").parent().children('li.star');
                    for (i = 0; i < unapprovedata.stars; i++) {
                        $(stars[i]).addClass('star hover selected');
                    }
                    $('#stars').val(unapprovedata.stars);
                    $(document).ready(function() {
                        $("#stars li").load(function() {});
                    });
                    $('#rating_id').val(rtd.rating_id);
                    $('#stars').val(unapprovedata.stars);
                    $('#reviewComments').val(unapprovedata.comments);
                }
                else
                {
                    $("#rating-widget").remove();
                    $("#rating-stars").remove();
                    if (response['tags'].length > 0)
                    {
                        for (i = 0; i < response['tags'].length; i++)
                        {
                            tags = response['tags'][i].tag;
                            tagid = response['tags'][i].ratingTag_id;
                            $('#review-tags').append('<option value="' + tagid + '" selected>' + tags + '</option>');
                        }
                    }
                    if (rtd != null)
                    {
                        let rs = rtd.stars * 20;
                        let stars = $("#stars li").parent().children('li.star');
                        for (i = 0; i < rtd.stars; i++)
                        {
                            $(stars[i]).addClass('star hover selected');
                        }
                        $('#stars').val(rtd.stars);
                        $(document).ready(function() {
                            $("#stars li").load(function() {});
                        });
                        $('#rating_id').val(rtd.rating_id);
                        $('#stars').val(rtd.stars);
                        $('#reviewComments').val(rtd.comments);
                    }
                }
            }
            $('#feedbackVendorId').val(receiver.id);
            $('#feedbackWorkId').val(receiver.wid);
            let title = getWorkstreamHeader(receiver.subject,receiver.companyName,stageName,receiver.name,receiver.wid);
            let sub = '<h6><b>' + receiver.subject + '</b></h6>';
            $('.subject').html(sub);
            $('.modal-title').html(title);
            $('#feedback').modal("show");
        }
    });
});

$('#feedback').on('hidden.bs.modal', function () 
{
    console.log('ok');
    location.reload();
});

//send message 
$(document).on("click", ".feedback", function()
{
    let workstreamId = document.getElementById("workstreamId").value;
    let msg=$.trim($("#message").val());
    let file=$.trim($("#upload-file").val());

    if(msg=='' && file=='')
    {
        return;
    }
    else
    {
        messagesend();
    }
});

//messagesend function
let i = 0;
let p = 0;
function messagesend()
{

    $(document).ajaxSend(function() {
        $("#overlay").fadeIn(300);
    });
    let baseurl = "{{url('/')}}";
    let formData = new FormData();
    let totalfiles = document.getElementById('upload-file').files.length;
    for (let index = 0; index < totalfiles; index++) {
        formData.append("fileToUpload[]", document.getElementById('upload-file').files[index]);
    }
    if ($("#subject").val() == '')
    {
        formData.append("subject", $(".subject").val());
    }
    else
    {
        formData.append("subject", $("#subject").val());
    }
    formData.append("workstreamId", $("#workstreamId").val());
    formData.append("emails[]", $("#emails").val());
    formData.append("vendors[]", $("#vendors").val());
    formData.append("message", $("#message").val());
    document.querySelector("#message").value = "";
    document.getElementById('filename').innerHTML = "";
    $.ajax(
    {
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        url:  '/contact-save',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        dataType: 'json',
        //enctype     : "multipart/form-data",   //it is done inside jquery
        success: function(response)
        {
            let receiver = response.receiver;
            let messages = response.messages;
            let name = receiver.name;
            document.getElementById('filename').innerHTML = "";
            //$('.reciver-name').html(receiver.name);
            $('#vendors').val(receiver.id);
            //$('#subject').val(receiver.subject);
            $('#emails').val(receiver.email);
            let msg = "";
            for (i = 0; i < messages.length; i++)
            {
                $('#workstreamId').val(messages[i].wid);
                let now = messages[i].updated_at;
                let date1 = new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                let date = date1[0] + ', ' + date1[1] + ' ' + date1[2] + ', ' + date1[3];
                let time = now.substr(11, 5);
                if (messages[i].Sender_id == response['flag'])
                {
                    $('.datetime').html(messages[i].updated_at);
                    if (messages[i].messagefiles.length != 0)
                    {
                        if (messages[i].message != null)
                        {
                            msg += '<div class="bubble me inventor">' + messages[i].message + '<br>';
                        }
                        else
                        {
                            msg += '<div class="bubble me inventor">';
                        }
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url =  '/donwload-file/' + messages[i].messagefiles[p].id;
                            msg += '<a href="' + url + '"><i>' + messages[i].messagefiles[p].fileName + '</i></a><br>';
                        }
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                    else
                    {
                        msg += '<div class="bubble me inventor">' + messages[i].message + '<br><span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                }
                else
                {
                    $('.datetime').html(messages[i].updated_at);
                    if (messages[i].messagefiles.length != 0)
                    {
                        if (messages[i].message != null)
                        {
                            msg += '<div class="bubble me vendor">' + messages[i].message + '<br>';
                        }
                        else
                        {
                            msg += '<div class="bubble me vendor">';
                        }
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url =  '/donwload-file/' + messages[i].messagefiles[p].id;
                            msg += '<a href="' + url + '"><i>' + messages[i].messagefiles[p].fileName + '</i></a><br>';
                        }
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                    else
                    {
                        msg += '<div class="bubble you inventor">' + messages[i].message + '<br><span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                }
            }
            msg += "</div>";
            $('.chat').append(msg);
            $('#messageModal').modal("show");
            $('#filename').html('');
        }
    }).done(function() {
        setTimeout(function() {
            $("#overlay").fadeOut(300);
        }, 500);
    });
}

$(document).ready(function()
{
    document.onkeyup = enter;
    function enter(e)
    {
        let currentUrl = window.location.href;
        let urlParams = new URLSearchParams(new URL(currentUrl).search);
        let cuuid = urlParams.get("cuuid");
        let role = $.trim($("#role").val());
        let msg = $.trim($("#message").val());
        let file = $.trim($("#upload-file").val());
        if (e.which == 13)
        {
            let id = $("#search").attr("data-category-id");
            let search =$("#search").val();
            if(search == undefined || search == " " || search == "")
            {
                $(document).ajaxStart(function()
                {
                    $("#msgwait").addClass("d-block");
                    $("#msgwait").removeClass("d-none");
                });
                $(document).ajaxComplete(function() 
                {
                    $("#msgwait").addClass("d-none");
                    $("#msgwait").removeClass("d-block");
                });
                if (msg == '' && file == '')
                {
                    return;
                }
                else
                {
                    if (role == 2)
                    {
                        messagesend();
                    }
                    else
                    {
                        vendormessagesend();
                    }
                }
            }
            else
            {
                let id = $("#search").attr("data-category-id");
                let search =$("#search").val();
                let oc_id = $(".countryfilterdata").attr('data-orig-cat');
                let cat_id = $(".countryfilterdata").attr('data-category-id');
                let con = $(".countryfilterdata").find(':selected').attr("data-country-id")
                let st = $(".countryfilterdata").find(':selected').attr("data-state_id");
                let city_st = $(".countryfilterdata").find(':selected').attr("data-cstate-id");
                let state_con = $(".countryfilterdata").attr("data-scontry-id");
                let city_con = $(".countryfilterdata").attr("data-ccontry_id");
                let checkBoxArray = new Array();
                let country = new Array();
                let categorylist = [];
                let countrylist = [];
                let city = new Array();
                let state = new Array();
                let citylist = [];
                let statelist = [];
                $(':checkbox:checked').each(function(i) {
                    let categories = $(".countryfilterdata").attr("data-category-id")
                    if (categories != null) {
                        checkBoxArray.push(categories);
                    }
                });
                if (checkBoxArray.length == 0) {
                    categorylist += oc_id;

                } else {
                    while (checkBoxArray.length != 0) {
                        if (checkBoxArray.length == 1) {
                            categorylist += checkBoxArray.pop();
                        } else {
                            categorylist += (checkBoxArray.pop() + ", ");
                        }
                    }
                    categorylist += ',' + oc_id;

                }
                countrylist += con;
                $(document).ajaxSend(function() 
                {
                       $("#overlay").fadeIn(300);　
                });  
                $.ajax(
                {
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    url: '/search-vendor/' + id,
                    type: 'POST',
                    data:   {
                                "_token": $("input[name='_token']").val(),
                                "search": search,
                                "cuuid": cuuid,
                                "categorylist": categorylist,
                                "countrylist": countrylist,
                                'statelist': statelist,
                                'citylist': citylist,
                                'oc_id': oc_id
                            },
                    dataType: 'json',
                    success: function(response)
                    {
                        $('#vlist').html(response.html);
                        $(".load-more").css('display','none');
                        $("#search").val('');
                    }
                }).done(function() 
                {
                    setTimeout(function(){
                    $("#overlay").fadeOut(300);
                },500);
                }); 
            }
            
        }
    }
});
$(document).on("click", "#send", function()
{
    var workstreamId = document.getElementById("workstreamId").value;
    let msg=$.trim($("#message").val());
    let file=$.trim($("#upload-file").val());

    if(msg=='' && file=='')
    {
        return;
    }
    else
    {
        messagesend();
    }
});
//vendor message send 
$(document).on("click", "#sendvendor", function()
{
    let workstreamId = document.getElementById("workstreamId").value;
    let msg=$.trim($("#message").val());
    let file=$.trim($("#upload-file").val());
    if(msg=='' && file=='')
    {
        return;
    }
    else
    {
        vendormessagesend();
    }
});


function vendormessagesend()
{
    $(document).ajaxSend(function() {
        $("#overlay").fadeIn(300);
    });
    let baseurl = "{{url('/')}}";
    //let file_data = $("#upload-file").prop("files")[0];
    let formData = new FormData();
    let totalfiles = document.getElementById('upload-file').files.length;
    for (let index = 0; index < totalfiles; index++) {
        formData.append("fileToUpload[]", document.getElementById('upload-file').files[index]);
    }
    formData.append("subject", $("#subject").val());
    formData.append("workstreamId", $("#workstreamId").val());
    formData.append("emails", $("#emails").val());
    formData.append("inventor_id", $("#vendors").val());
    formData.append("message", $("#message").val());
    document.getElementById('filename').innerHTML = "";
    document.querySelector("#message").value = "";
    $.ajax(
    {
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        url:  '/vendor-reply',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        dataType: 'json',
        //enctype     : "multipart/form-data",   //it is done inside jquery
        success: function(response)
        {
            console.log(response);
            let work = response['work'];
            let receiver = response['receiver'];
            let messages = response['messages'];
            let name = receiver.name;
            document.getElementById('filename').innerHTML = "";
            $('#subject').val(receiver.subject);
            $('#vendors').val(receiver.id);
            $('#emails').val(receiver.email);
            let msg = "";
            for (i = 0; i < messages.length; i++)
            {
                $('.datetime').html(messages[i].updated_at);
                $('#workstreamId').val(messages[i].wid);
                let now = messages[i].updated_at;
                let date1 = new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                let date = date1[0] + ', ' + date1[1] + ' ' + date1[2] + ', ' + date1[3];
                let time = now.substr(11, 5);
                if (messages[i]['Sender_id'] == response['flag'])
                {
                    $('.datetime').html(messages[i].updated_at);
                    if (messages[i].messagefiles.length != 0)
                    {
                        if (messages[i].message != null)
                        {
                            msg += '<div class="bubble me inventor">' + messages[i].message + '<br>';
                        }
                        else
                        {
                            msg += '<div class="bubble me inventor">';
                        }
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url =  '/donwload-file/' + messages[i].messagefiles[p].id;
                            msg += '<a href="' + url + '"><i>' + messages[i].messagefiles[p].fileName + '</i></a><br>';
                        }
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                    else
                    {
                        msg += '<div class="bubble me inventor">' + messages[i].message + '<br><span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                }
                else
                {
                    $('.datetime').html(messages[i].updated_at);
                    if (messages[i].messagefiles.length != 0)
                    {
                        if (messages[i].message != null)
                        {
                            msg += '<div class="bubble you vendor">' + messages[i].message + '<br>';
                        }
                        else
                        {
                            msg += '<div class="bubble you vendor">';
                        }
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url =  '/donwload-file/' + messages[i].messagefiles[p].id;
                            msg += '<a href="' + url + '"><i>' + messages[i].messagefiles[p].fileName + '</i></a><br>';
                        }
                        msg += '<span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                    else
                    {
                        msg += '<div class="bubble you inventor">' + messages[i].message + '<br><span class="timestamp">' + date + '&nbsp;' + time + '</span></div>';
                    }
                }
            }
            msg += "</div>";
            $('.chat').append(msg);
            $('#messageModal').modal("show");
            $('#filename').html('');
        }
    }).done(function() {
        setTimeout(function() {
            $("#overlay").fadeOut(300);
        }, 500);
    });
}

//msg pop-up
$(document).on("click", ".status", function()
{
       let id = $(this).data('id');
       $.ajax(
        {
            url:  '/status/' + id,
            type: 'GET',
            dataType: 'json',
            success: function(response)
            {
            }
        });
});
$(document).on("click", ".msg", function()
{

       let id = $(this).data('id');
       let urltype = window.location.pathname.split('/')[2] ;
       if(urltype == 'quotes' || urltype == 'accounts')
       {
            $("#profile-tab").addClass("active");
            $("#profile-tab-pane").addClass("active");
            $("#profile-tab-pane").addClass("show");
            $("#home-tab-pane").removeClass("active");
            $("#home-tab-pane").removeClass("show");
            $("#home-tab").removeClass("active");
       }
       else
       {
            $("#home-tab").addClass("active");
            $("#home-tab-pane").addClass("active");
            $("#home-tab-paneb").addClass("show");
            $("#profile-tab-pane").removeClass("active");
            $("#profile-tab-pane").removeClass("show");
            $("#profile-tab").removeClass("active");
       }
       $.ajax(
        {
            url:  '/workstream/message/' + id,
            type: 'GET',
            dataType: 'json',
            success: function(response)
            {
                let qstatus = '';
                var work = response['work'];
                var status = response['status'];
                var quote = response['quote'];
                let stageCategory = response['stageCategory'];
                let stageName = null;
                let stageID = null;
                if(stageCategory != null)
                {
                     stageName = stageCategory.stageName;
                     stageID = stageCategory.stage_id;
                }
                var qdata = response['qdata'];
                var budget = response['budget'];
                //alert(qdata.quote_id);
                var quotelist = response['quotelist'];
                console.log(quotelist);
                var quotelinelist = response['quotelinelist'];
                var ewid = response['ewid'];
                let quotefile = response['quotefile'];
                //alert(quotefile.length);
                        let qturl = "/inventor-quote/" + ewid;
                let quotetable ="";
                let i = 0;
                let j = 0;
                if(quote.length > 0)
                {
                    for (i = 0; i < quotelist.length; i++)
                    {
                            var now =quotelinelist[i].updated_at;
                            var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                            var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                            var time=now.substr(11, 5);
                        quotetable +='<h1>Quote Reference: '+quotelist[i].quoteRef_id+'</h1><b><center>Time: '+time+'</center></b>';
                            //alert(date);
                            quotetable +='<table id="qid" border="2" style="float:right;width: 36%;"><tr><th>Date</th><td>'+date+'</td></tr>';
                            if(quotelist[i].quoteRef_id != null)
                            {
                                /*quotetable +='<tr><th>QuoteRef</th><td>'+quotelist[i].quoteRef_id+'</td></tr></table>';*/
                            }
                            else
                            {
                                quotetable +='</table>'
                            }

                        quotetable +='<table id="qitm"><tr><th>Item</th><th>Rate</th><th>Quantity</th><th>Tax %</th><th>Price</th></tr>';
                        for (j = 0; j < quotelinelist.length;j++)
                        {
                            //alert(date);
                            if(quotelinelist[j].quote_id == quotelist[i].quote_id)
                            {
                                quotetable +='<tr><td>'
                                              +quotelinelist[j].item+
                                              '</td><td>$'+
                                              +quotelinelist[j].rate+
                                              '</td><td>'+
                                              +quotelinelist[j].quantity+
                                              '</td><td>'+
                                              +quotelinelist[j].tax+
                                              '</td><td>$'+
                                              +quotelinelist[j].price+
                                              '</td></tr>';
                            }
                            
                        }
                        quotetable +='</table>';
                        quotetable +='<table id="qid" border="2" style="float:right;width: 50%;">';
                        if(quotelist[i].extra != null)
                        {
                            quotetable +='<tr><th>Extra</th><td style="width: 58%;">$'+quotelist[i].extra+'</td></tr>';
                        }
                        if(quotelist[i].discount != null)
                        {
                            quotetable +='<tr><th>Discount</th><td style="width: 58%;">$'+quotelist[i].discount+'</td></tr>';
                        }
                        quotetable +='<tr><th>Total Amount</th><td style="width: 58%;">$'+quotelist[i].finalprice+'</td></tr></table><br>';
                        quotetable +='<a href="'+ qturl +'" class="sign " target="blank">Quote Details</a>';
                        
                        if(quotelist[i].quote_status == 'Submited')
                        {
                             qstatus = "Received";
                        }
                        else
                        {
                             qstatus = quotelist[i].quote_status;

                        }
                        quotetable += '<select data-current="' + quotelist[i].quote_status + '" style="height:40px" name="quotestatus" id="quotestatus" selected onchange="quotestatus(' + quotelist[i].quote_id + ');" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '"><option value="' + qstatus + '">' + qstatus + '</option>';
                        if(quotelist[i].quote_status == 'Submited')
                        {
                            quotetable += '<option data-current="' + quotelist[i].quote_status + '" value="Shortlisted" class="quotestatus"  data-id="Shortlisted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Shortlist</option><option value="Accepted" class="quotestatus"  data-id="Accept" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Accept</option><option value="Rejected" data-id="Reject" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Reject</option></select><br>';
                            
                        }
                        else if(quotelist[i].quote_status == 'Accepted')
                        {
                            quotetable += '<option value="Shortlisted" data-current="' + quotelist[i].quote_status + '" class="quotestatus"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Shortlisted">Shortlist</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Rejected"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Rejected">Reject</option></select><br>';
                            
                        }
                        else if(quotelist[i].quote_status == 'Shortlisted')
                        {
                            quotetable += '<option value="Rejected" data-current="' + quotelist[i].quote_status + '" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Rejected">Reject</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Accepted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Accepted">Accept</option></select><br>';
                            
                        }
                        else
                        {
                            quotetable += '<option value="Shortlisted" data-current="' + quotelist[i].quote_status + '" class="quotestatus"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Shortlisted">Shortlist</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Accepted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Accepted">Accept</option></select><br>';
                        }

                        if(quotelist[i].quote_status == 'Submited')
                        {
                             qstatus = "Received";
                        }
                        else
                        {
                             qstatus = quotelist[i].quote_status;

                        }
                        if(budget != null)
                        {
                            quotetable +='<br><a href="javascript:void(0)" class="accountsign payment" data-bid="'+budget.budget_id+'" data-cname="" data-stage="Research" data-project="New project">Invention Management</a>';
                        }
                        $('#pqid').val(quotelist[i].quote_id);
                        $('#pfinalprice').val(quotelist[i].finalprice);
                        $('#cstatus').val(quotelist[i].quote_status);
                        
                        /*quotetable +='<select style="height:40px" name="quotestatus" id="quotestatus" selected onchange="qstatus('+quotelist[i].quote_id+');">';
                        var quoteStatusOptions = ['Received', 'Accepted', 'Shortlisted', 'Rejected'];
                        for(j=0; j<quoteStatusOptions.length; j++)
                        {
                            quotetable += '<option value="' + quoteStatusOptions[j] +'"'+ (quotelist[i].quote_status == quoteStatusOptions[j] ? ' selected ' : '')+'>'+quoteStatusOptions[j]+'</option>'
                        }
                        quotetable +='</select>';*/


                        //quotetable +='<a class="nav-link btn-warning dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Quote Status</a>';
                        //quotetable +='<div class="dropdown-menu"><a class="dropdown-item qtstatus" href="#">Received </a><a class="dropdown-item qtstatus" href="#">Accepted </a><a class="dropdown-item qtstatus" href="#">Rejected</a></div><br>';

                    }
                    if(quotefile.length > 0)
                    {
                        console.log(quotefile)
                        quotetable +='<br><br><b>Attachment</b>'
                        for (i = 0; i < quotefile.length; i++)
                        {
                            let furl = "/quote/donwloadfile/" + quotefile[i].quoteFile_id;
                            quotetable +='<a href="'+ furl +'" target="_blank"><br>'+quotefile[i].fileName+'</a>';
                        }
                    }
                    //alert(quotetable);
                    
                    /*let url = "/admin/delete/vendor/ads/" + id;
                    $("#deletevads").attr("href", url);*/
                    $("#nolink").addClass("d-none");
                    $("#nolink").removeClass("d-block");
                    $(".quote-list").addClass("d-block");
                    $(".quote-list").removeClass("d-none");
                    var url = "/viewquote/" + response['workid'];
                    $("#linkquote").attr("href", url);
                    
                }
                else
                {
                    $("#qlink").addClass("d-none");
                    $("#qlink").removeClass("d-block");
                    $("#nolink").addClass("d-block");
                    $("#nolink").removeClass("d-none");
                }
                if(status.workstreamStatus == 1)
                {

                    $("#workclose").addClass("d-none");
                    $("#workclose").removeClass("d-block");
                    $("#workopen").addClass("d-block");
                    $("#workopen").removeClass("d-none");
                    $("#write").addClass("d-none");
                    $("#write").removeClass("d-block");
                    $("#workstatus").addClass("d-block");
                    $("#workstatus").removeClass("d-none");

                    /*$("#write").remove();
                    $('#workclose').remove();
                    $("#workopen").addClass("d-block");
                    $("#workopen").removeClass("d-none");*/

                }
                else
                {
                    $("#workclose").addClass("d-block");
                    $("#workclose").removeClass("d-none");
                    $("#workopen").addClass("d-none");
                    $("#workopen").removeClass("d-block");
                    $("#write").addClass("d-block");
                    $("#write").removeClass("d-none");
                    $("#workstatus").addClass("d-none");
                    $("#workstatus").removeClass("d-block");
                }
                console.log(status.workstreamStatus);
                var receiver = response['receiver'];
                var messages = response['messages'];
                var name = receiver.name;
                var tags=[];
                //alert(response['tags'].length);
                if(response['rt'].length > 0)
                {
                    //alert('feedback');
                    $("#rating-widget").remove();
                    $("#rating-stars").remove();
                    
                    for (i = 0; i < response['tags'].length; i++)
                    {
                        //alert(response['tags'][i].tag);
                        tags  += response['tags'][i].tag+',';
                    }
                    //alert(tags);
                    var rs =receiver.stars * 20;
                    //alert(rs);
                    var stars = $("#stars li").parent().children('li.star');
                    //alert(stars);
                    for (i = 0; i < receiver.stars; i++) 
                    {
                      $(stars[i]).addClass('star hover selected');
                    }
                    $('#stars').val(receiver.stars);
                    //$('.prostar').html('<span style="width:'+rs+'%" class="star-ratings-sprite-rating"></span></a>');
                    //var onStar = parseInt(receiver.stars, 10);
                    //alert(receiver.stars);
                    $(document).ready(function(){
                      $("#stars li").load(function(){
                        
                      });
                    });
                    
                    //$('#review-tags').val(tags);
                    //$('#review-tags').tagsinput('add',tags);
                    $('#rating_id').val(receiver.rating_id);
                    $('#stars').val(receiver.stars);
                    $('#reviewComments').val(receiver.comments);
                }
                

                //$('.reciver-name').html(receiver.name);
                //document.getElementById('filename').innerHTML="";
                $('.subject').val(receiver.subject);
                //let msg = '<div class="chat text-dark" data-chat="person2" id="msg">';
                $('#vendors').val(receiver.id);
                $('#feedbackVendorId').val(receiver.id);

                $('#emails').val(receiver.email);
                let msg="";
                var inventor=[];
                /*if(quote.length > 0)
                {
                    
                    for (i = 0; i < quote.length; i++)
                    {
                        let qurl="/inventor-quote/" + quote[i].quote_id;
                        var now =quote[i].updated_at;
                        var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                        var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                        var time=now.substr(11, 5);
                        msg += '<div class="bubble you vendor">'+'Quotation Recived <br>'+
                        '<a href="'+qurl+'" target="blank">'+'Quote #: '+quote[i].quote_id+'</a><br>'+
                        '<a href="'+qurl+'" target="blank">'+'Ref: '+quote[i].quoteRef_id+'</a><br>'+
                        '<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>';
                    }

                    
                }*/
                
                for (i = 0; i < messages.length; i++)
                {

                //$('.conversation-start').html(messages[i].updated_at);
                $('#workstreamId').val(messages[i].wid);
                $('#feedbackWorkId').val(messages[i].wid);


                    if(messages[i].Sender_id==response['flag'])
                    {
                        if(messages[i].quote_status == 1)
                        {
                            $("#workquotestatusb").addClass("d-block");
                            $("#workquotestatusb").removeClass("d-none");
                            var url = "/viewquote/" + response['workid'];
                            $("#workquotestatus").attr("href", url);
                        }
                        else
                        {
                            $("#workquotestatusb").removeClass("d-block");
                            $("#workquotestatusb").addClass("d-none");

                        }
                        var now =messages[i].updated_at;
                        var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                        var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                        var time=now.substr(11, 5);
                        console.log(date1);
                        let file =messages[i].messagefiles;
                        msg +='<div class="conversation-start"></div>';
                        
                        if(messages[i].message != null)
                        {
                        msg += '<div class="bubble me inventor">'
                           +messages[i].message+'<br>';
                           //alert(msg);
                        }
                        else
                        {
                            msg += '<div class="bubble me inventor">';
                        }
                        if(messages[i].messagefiles.length != 0)
                        {
                            msg +='<br>';
                            for (p = 0; p < messages[i].messagefiles.length; p++)
                            {
                                let url='/donwload-file/'+messages[i].messagefiles[p].id;
                                msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</i></a><br>';
                            }
                            msg +='<span class="timestamp">'+date+time+'</span></div>';
                        }
                        else
                        {
                            msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
                        }

                    }
                    else
                    {

                        /*if(messages[i].quote == 1)
                        {
                            if(qdata.quote_id != null)
                            {
                                if(qdata.quoteRef_id != null)
                                {
                                    //alert(quote[i].quoteRef_id);  
                                    messages[i].message ='Quotation Received<br>'+'<a href="'+qturl+'" target="blank">'+'Quote #: '+qdata.quote_id+'</a><br>'+'<a href="'+qturl+'" target="blank">'+'Ref: '+qdata.quoteRef_id+'</a><br>'+'<a href="'+qturl+'" target="blank">'+'Amount #: '+qdata.finalprice+'</a>';
                                }
                                else
                                {
                                    messages[i].message ='Quotation Received<br>'+'<a href="'+qturl+'" target="blank">'+'Quote #: '+qdata.quote_id+'</a><br>'+'<a href="'+qturl+'" target="blank">'+'Amount #: '+qdata.finalprice+'</a>';
                                }
                            }
                            else
                            {
                                //alert("ok");
                                messages[i].message ='Quotation Received<br>'+'<a href="'+qturl+'" target="blank">'+'Amount #: '+qdata.finalprice+'</a>';
                            }
                            
                        }*/
                        var now =messages[i].updated_at;
                        var date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                        var date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                        var time=now.substr(11, 5);
                        if(messages[i].message != null)
                        {
                        msg += '<div class="bubble you vendor">'
                           +messages[i].message+'<br>';
                        }
                        else
                        {
                            msg += '<div class="bubble you vendor">';
                        }
                        if(messages[i].messagefiles.length != 0)
                        {
                            msg +='<br>';
                            for (p = 0; p < messages[i].messagefiles.length; p++)
                            {
                                let url='/donwload-file/'+messages[i].messagefiles[p].id;
                                msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</a><br>';
                            }
                            msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>';

                        }
                        else
                        {
                            msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
                        }
                    }
                msg += "</div>";
                let title = getWorkstreamHeader(receiver.subject,receiver.companyName,stageName,receiver.name,receiver.wid);
                var sub= '<h6><b>'+receiver.subject+'</b></h6>';
                $('.subject').html(sub);
                $('.modal-title').html(title);

                //$('.conversation-start').html(date);
                $('.chat').append(msg);
                $('.quote-list').html(quotetable);
                $('#paymentdetails').modal("hide");
                $('#messageModal').modal("show");
                $('#overlay').fadeOut("300");

                }
            }
        });
    });
$(document).on("mouseover", "#stars li", function()
{
    /* 1. Visualizing things on Hover - See next part for action on click */
        var onStar = parseInt($(this).data('value'), 10); // The star currently mouse on
        // Now highlight all the stars that's not after the current hovered star
        $(this).parent().children('li.star').each(function(e) {
            if (e < onStar) {
                $(this).addClass('hover');
            }
            else {
                $(this).removeClass('hover');
            }
        });
    }).on('mouseout', function() {
        $(this).parent().children('li.star').each(function(e) {
            $(this).removeClass('hover');
        });
    });
    /* 2. Action to perform on click */
$(document).on("click", "#stars li", function()
{
        var onStar = parseInt($(this).data('value'), 10); // The star currently selected
        var stars = $(this).parent().children('li.star');
        //alert(onStar);
        let i = 0;
        for (i = 0; i < stars.length; i++) {
            $(stars[i]).removeClass('selected');
        }
        for (i = 0; i < onStar; i++) {
            $(stars[i]).addClass('selected');
        }
        // JUST RESPONSE (Not needed)
        var ratingValue = parseInt($('#stars li.selected').last().data('value'), 10);
        //alert(ratingValue);
        $('#stars').val(ratingValue);
        /*var msg = "";
        if (ratingValue > 1) {
          msg = "Thanks! You rated this " + ratingValue + " stars.";
        }
        else {
          msg = "We will improve ourselves. You rated this " + ratingValue + " stars.";
        }
        responseMessage(msg);*/
});

$(document).on("click", "#upload", function()
{
    $("#upload-file").trigger('click');
});

$(document).on("change", "#quotestatus", function(e)
{
    let wid = $("#quotestatus").data('qid');
    let current_status = $('#quotestatus').data('current');
    var status = $('#quotestatus').find(":selected").val();
    if(status == 'Accepted' || status == 'Accept')
    {
        //alert("accepted");
        let qid = $(this).data('qid');
        let price = $(this).data('price');
        let category = $(this).data('category');
        let stage_id = $(this).data('stageid');
        $.ajax(
        {
            type:"get",
            url:  '/getStageCategories',
            success:function(res)
            {
                console.log(res);
                if(res)
                {
                    $(".pproject-stage").empty();
                    $.each(res,function(key,value)
                    {
                        if(stage_id != value)
                        {
                            $(".pproject-stage").append('<option value="'+value+'">'+key+'</option>');

                        }
                        else
                        {
                            $(".pproject-stage").append('<option value="'+value+'" selected>'+key+'</option>');

                        }
                    });
                }
            }
        })
        $("#accountstatus").addClass("d-block");
        $("#accountstatus").removeClass("d-none");
        
    }
    else
    {
        if(current_status == 'Accepted')
        {
            //alert("true");
            if(confirm('This operation will also delete any payments recorded against this quote. Are you sure you want to proceed?')) 
            {
                $(document).ajaxSend(function() {
                    $("#overlay").fadeIn(300);　
                });
                $.ajax({
                    headers: {
                      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                    },
                    url:  '/quotestatus',
                    type: 'POST',
                    data: {"status":status, "wid":wid},
                    success: function (ajaxResponse) 
                    {
                        alert("Status Updated");
                        window.location.reload();
                    }
                }).done(function() {
                        setTimeout(function(){
                            $("#overlay").fadeOut(300);
                        },500);
                });
            }
            else
            {
                window.location.reload();
                e.preventDefault();
            }
        }
        else
        {
            $('#cstatus').val();
            $("#accountstatus").addClass("d-none");
            $("#accountstatus").remove("d-block");
            $(document).ajaxSend(function() {
                $("#overlay").fadeIn(300);　
            });
            $.ajax({
                headers: {
                  'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                url:  '/quotestatus',
                type: 'POST',
                data: {"status":status, "wid":wid},
                success: function (ajaxResponse) 
                {
                    alert("Status Updated");
                    window.location.reload();
                }
            }).done(function() {
                    setTimeout(function(){
                        $("#overlay").fadeOut(300);
                    },500);
            });
            
        }
    }
    

});

$(document).on("change", ".quotestatus", function(e)
//function qstatus(wid, i, e)
{
    let i = $(this).data('qid');
    let wid = $(this).data('qid');
    /*let current_status =   $('select.nq').find(':selected').data('cstatus');*/
    let current_status = document.getElementById("ct-" + i).value;

    console.log($('#ct-' + i));
    //alert(current_status);
    /*let current_status1 =   $('select.nq').find(':selected').attr('data-cstatus');
    alert(current_status1);*/
    var status = document.getElementById("quotestatusdata-" + wid).value;
    if (status == 'Accepted')
    {
        let qid = $('#quotestatusdata-' + wid).data('qid');
        let price = $('#quotestatusdata-' + wid).data('price');
        let cname = $('#quotestatusdata-' + wid).data('cname');
        $(document).ajaxSend(function() {
            $("#overlay").fadeIn(300);
        });
        $.ajax({
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            url:  '/quoteAcceptData',
            type: 'POST',
            data: {
                "qid": qid,
                "cname": cname,
                "price": price
            },
            success: function(ajaxResponse)
            {
                $('#qid').val(qid);
                $('#finalprice').val(price);
                $('#quotecategory').html(ajaxResponse.html);
                $('#quotecategory').modal("show");
            }
        }).done(function() {
            setTimeout(function() {
                $("#overlay").fadeOut(300);
            }, 500);
        });
        
    }
    else
    {
        //alert("here");
        if (current_status == 'Accepted')
        {
            //alert("true");
            if (confirm('This operation will also delete any payments recorded against this quote. Are you sure you want to proceed?'))
            {
                $(document).ajaxSend(function() {
                    $("#overlay").fadeIn(300);
                });
                $.ajax({
                    headers: {
                        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                    },
                    url:  '/quotestatus',
                    type: 'POST',
                    data: {
                        "status": status,
                        "wid": wid
                    },
                    success: function(ajaxResponse)
                    {
                        alert("Status Updated");
                        window.location.reload();
                    }
                }).done(function() {
                    setTimeout(function() {
                        $("#overlay").fadeOut(300);
                    }, 500);
                });
            }
            else
            {
                window.location.reload();
                e.preventDefault();
            }
        }
        else
        {
            //alert("2nd");
            $(document).ajaxSend(function() {
                $("#overlay").fadeIn(300);
            });
            $.ajax({
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                url:  '/quotestatus',
                type: 'POST',
                data: {
                    "status": status,
                    "wid": wid
                },
                success: function(ajaxResponse)
                {
                    alert("Status Updated");
                    window.location.reload();
                }
            }).done(function() {
                setTimeout(function() {
                    $("#overlay").fadeOut(300);
                }, 500);
            });
        }
    }
});

$(document).on("click", ".workclose", function(e)
{
    if (confirm("You won't be able to send or receive any messages after the workstream has been closed.\nAre you sure you want to close this workstream?"))
    {
        let workstreamId = document.getElementById("workstreamId").value;
        let status = 1;
        $.ajax({
            type: "post",
            data: {
                "_token": $("input[name='_token']").val(),
                "status": status
            },
            url:  '/closeworkstream/' + workstreamId,
            success: function(res)
            {
                $("#workclose").addClass("d-none");
                $("#workclose").removeClass("d-block");
                $("#workopen").addClass("d-block");
                $("#workopen").removeClass("d-none");
                $("#workstatus").addClass("d-block");
                $("#workstatus").removeClass("d-none");
                $("#write").addClass("d-none");
                $("#write").removeClass("d-block");
            }
        });
    }
    else
    {
        event.preventDefault();
    }
});
$(document).on("click", ".workopen", function(e)
{
    let workstreamId = document.getElementById("workstreamId").value;
    let status = 0;
    $.ajax({
        type: "post",
        data: {
            "_token": $("input[name='_token']").val(),
            "status": status
        },
        url:  '/closeworkstream/' + workstreamId,
        success: function(res)
        {
            $("#write").addClass("d-block");
            $("#workopen").addClass("d-none");
            $("#workclose").addClass("d-block");
            $("#workstatus").addClass("d-none");
            $("#write").removeClass("d-none");
            $("#workopen").removeClass("d-block");
            $("#workclose").removeClass("d-none");
            $("#workstatus").removeClass("d-block");
        }
    });
});

$(document).on("click", ".categorydata", function(e)
{
    let data = $('#inventorcategory').val();
    let txt = $('#inventorcategory').find('option:selected').text();
    localStorage.setItem("inventionCategory", data);
    $('.categorychange').html(txt);
    $('#categoryModal').modal('hide');
});

$(document).on("change", ".imageuploadvalidation", function()
{
    let fileName = $(".imageuploadvalidation").val();
    if (fileName == '')
    {
        fileName = document.getElementById('fileToUpload1').value;
    }
    if (fileName == '')
    {
        fileName = document.getElementById('fileToUpload').value;
    }
    let idxDot = fileName.lastIndexOf(".") + 1;
    let extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "webp" || extFile == "svg")
    {
        //TO DO
    }
    else
    {
        alert("Only jpg/jpeg and png files are allowed!");
        $(".imageuploadvalidation").val('');
    }
});
$('#quotecategory').on('hidden.bs.modal', function()
{
    //alert("here");
    window.location.reload();
});

$(document).ready(function()
{
    $('#messageModal,#feedback').on('hidden.bs.modal', function() 
    {
        let type = $(".close").data('category');
        if (type != undefined) {
            //alert("bh");
            if (type == 'workstream') 
            {
                let getUrl = window.location;
                let quoteUrl = "/" + getUrl.pathname.split('/')[1] + "/" + getUrl.pathname.split('/')[2];
                if(quoteUrl != '/inventor/quotes')
                {
                    window.location.reload();
                }
                
                //var url = "<?php echo $data['work'] ?>";
            } else if (type == 'rating') {
                window.location.reload();
                //var url = "<?php echo $rating ?>";
            } else if (type == 'account') {
                window.location.reload();
                //var url = "<?php echo $accountdetails ?>";
            } else {
                window.location.reload();
                //var url = "<?php echo $quote ?>";
            }
            //window.location.href = url;
        } else {
            let type = $("#close").data('category');
            //alert(type);
            if (type == 'account') 
            {
                //window.location.reload();
            } 
            else 
            {
                //var url = "<?php echo $quote ?>";
                //window.location.href = url;
                window.location.reload();
            }

        }


        //window.location = window.location.href.split("?")[0];
    });
});

function getWorkstreamHeader(subject, companyName, stageName, name, wid)
{
    let title = '<center><h4><b>RFQ Subject - '+ subject + '</b></h4></center><span class="name reciver-name"><h4><center>' + companyName + '<br>'+ stageName +'</center></h4></span><br>' +'<span class="pull-left"><h5>' + name + '</h5></span>' + '<span class="pull-right"><h5>WId:' + wid + '</h5></span>';
    return title;
}
$(document).ready(function () 
{
    $('#messageModal').on('shown.bs.modal', function () 
    {
        let divXScrollHeight = $('.chat').prop('scrollHeight');
        $(".chat").animate({scrollTop: divXScrollHeight}, 'fast');
    });
});
$(document).ready(function()
{
    setInterval(function()
    {
        if($('#messageModal').hasClass('d-block')) 
        {
            let id = $("#workstreamId").val();
            let userRole = $("#userRole").val();
            if(userRole == 2)
            {
                inventorMessageRefresh(id);
            }
            if(userRole == 3)
            {
                vendorMessageRefresh(id);
            }
        } 
    },30000);
});

function inventorMessageRefresh(id)
{
    $.ajax(
    {
        url:  '/workstream/message/' + id,
        type: 'GET',
        dataType: 'json',
        success: function(response)
        {
            let qstatus = '';
            var work = response['work'];
            var status = response['status'];
            var quote = response['quote'];
            let stageCategory = response['stageCategory'];
            let stageName = null;
            let stageID = null;
            if(stageCategory != null)
            {
                 stageName = stageCategory.stageName;
                 stageID = stageCategory.stage_id;
            }
            let qdata = response['qdata'];
            let budget = response['budget'];
            let quotelist = response['quotelist'];
            let quotelinelist = response['quotelinelist'];
            let ewid = response['ewid'];
            let quotefile = response['quotefile'];
            let qturl = "/inventor-quote/" + ewid;
            let quotetable ="";
            let i = 0;
            let j = 0;
            if(quote.length > 0)
            {
                for (i = 0; i < quotelist.length; i++)
                {
                    let now =quotelinelist[i].updated_at;
                    let date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                    let time=now.substr(11, 5);
                    quotetable +='<h1>Quote Reference: '+quotelist[i].quoteRef_id+'</h1><b><center>Time: '+time+'</center></b>';
                    quotetable +='<table id="qid" border="2" style="float:right;width: 36%;"><tr><th>Date</th><td>'+date+'</td></tr>';
                    if(quotelist[i].quoteRef_id != null)
                    {
                    }
                    else
                    {
                        quotetable +='</table>'
                    }
                    quotetable +='<table id="qitm"><tr><th>Item</th><th>Rate</th><th>Quantity</th><th>Tax %</th><th>Price</th></tr>';
                    for (j = 0; j < quotelinelist.length;j++)
                    {
                        if(quotelinelist[j].quote_id == quotelist[i].quote_id)
                        {
                            quotetable +='<tr><td>'
                                          +quotelinelist[j].item+
                                          '</td><td>$'+
                                          +quotelinelist[j].rate+
                                          '</td><td>'+
                                          +quotelinelist[j].quantity+
                                          '</td><td>'+
                                          +quotelinelist[j].tax+
                                          '</td><td>$'+
                                          +quotelinelist[j].price+
                                          '</td></tr>';
                        }
                        
                    }
                    quotetable +='</table>';
                    quotetable +='<table id="qid" border="2" style="float:right;width: 50%;">';
                    if(quotelist[i].extra != null)
                    {
                        quotetable +='<tr><th>Extra</th><td style="width: 58%;">$'+quotelist[i].extra+'</td></tr>';
                    }
                    if(quotelist[i].discount != null)
                    {
                        quotetable +='<tr><th>Discount</th><td style="width: 58%;">$'+quotelist[i].discount+'</td></tr>';
                    }
                    quotetable +='<tr><th>Total Amount</th><td style="width: 58%;">$'+quotelist[i].finalprice+'</td></tr></table><br>';
                    quotetable +='<a href="'+ qturl +'" class="sign " target="blank">Quote Details</a>';
                    
                    if(quotelist[i].quote_status == 'Submited')
                    {
                         qstatus = "Received";
                    }
                    else
                    {
                         qstatus = quotelist[i].quote_status;

                    }
                    quotetable += '<select data-current="' + quotelist[i].quote_status + '" style="height:40px" name="quotestatus" id="quotestatus" selected onchange="quotestatus(' + quotelist[i].quote_id + ');" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '"><option value="' + qstatus + '">' + qstatus + '</option>';
                    if(quotelist[i].quote_status == 'Submited')
                    {
                        quotetable += '<option data-current="' + quotelist[i].quote_status + '" value="Shortlisted" class="quotestatus"  data-id="Shortlisted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Shortlist</option><option value="Accepted" class="quotestatus"  data-id="Accept" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Accept</option><option value="Rejected" data-id="Reject" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '">Reject</option></select><br>';
                        
                    }
                    else if(quotelist[i].quote_status == 'Accepted')
                    {
                        quotetable += '<option value="Shortlisted" data-current="' + quotelist[i].quote_status + '" class="quotestatus"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Shortlisted">Shortlist</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Rejected"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Rejected">Reject</option></select><br>';
                        
                    }
                    else if(quotelist[i].quote_status == 'Shortlisted')
                    {
                        quotetable += '<option value="Rejected" data-current="' + quotelist[i].quote_status + '" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Rejected">Reject</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Accepted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Accepted">Accept</option></select><br>';
                        
                    }
                    else
                    {
                        quotetable += '<option value="Shortlisted" data-current="' + quotelist[i].quote_status + '" class="quotestatus"  data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Shortlisted">Shortlist</option><option value="Submited" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Submited">Received</option><option value="Accepted" data-qid="' + quotelist[i].quote_id + '" data-price="' + quotelist[i].finalprice + '" data-category="' + stageName + '" data-stageID="' + stageID + '" data-id="Accepted">Accept</option></select><br>';
                    }

                    if(quotelist[i].quote_status == 'Submited')
                    {
                         qstatus = "Received";
                    }
                    else
                    {
                         qstatus = quotelist[i].quote_status;

                    }
                    if(budget != null)
                    {
                        quotetable +='<br><a href="javascript:void(0)" class="accountsign payment" data-bid="'+budget.budget_id+'" data-cname="" data-stage="Research" data-project="New project">Invention Management</a>';
                    }
                    $('#pqid').val(quotelist[i].quote_id);
                    $('#pfinalprice').val(quotelist[i].finalprice);
                    $('#cstatus').val(quotelist[i].quote_status);
                }
                if(quotefile.length > 0)
                {
                    console.log(quotefile)
                    quotetable +='<br><br><b>Attachment</b>'
                    for (i = 0; i < quotefile.length; i++)
                    {
                        let furl = "/quote/donwloadfile/" + quotefile[i].quoteFile_id;
                        quotetable +='<a href="'+ furl +'" target="_blank"><br>'+quotefile[i].fileName+'</a>';
                    }
                }
                $("#nolink").addClass("d-none");
                $("#nolink").removeClass("d-block");
                $(".quote-list").addClass("d-block");
                $(".quote-list").removeClass("d-none");
                let url = "/viewquote/" + response['workid'];
                $("#linkquote").attr("href", url);
            }
            else
            {
                $("#qlink").addClass("d-none");
                $("#qlink").removeClass("d-block");
                $("#nolink").addClass("d-block");
                $("#nolink").removeClass("d-block");
            }
            if(status.workstreamStatus == 1)
            {
                $("#workclose").addClass("d-none");
                $("#workclose").removeClass("d-block");
                $("#workopen").addClass("d-block");
                $("#workopen").removeClass("d-none");
                $("#write").addClass("d-none");
                $("#write").removeClass("d-block");
                $("#workstatus").addClass("d-block");
                $("#workstatus").removeClass("d-none");
            }
            else
            {
                $("#workclose").addClass("d-block");
                $("#workclose").removeClass("d-none");
                $("#workopen").addClass("d-none");
                $("#workopen").removeClass("d-block");
                $("#write").addClass("d-block");
                $("#write").removeClass("d-none");
                $("#workstatus").addClass("d-none");
                $("#workstatus").removeClass("d-block");
            }
            console.log(status.workstreamStatus);
            let receiver = response['receiver'];
            let messages = response['messages'];
            let name = receiver.name;
            let tags=[];
            if(response['rt'].length > 0)
            {
                $("#rating-widget").remove();
                $("#rating-stars").remove();
                for (i = 0; i < response['tags'].length; i++)
                {
                    tags  += response['tags'][i].tag+',';
                }
                let rs =receiver.stars * 20;
                let stars = $("#stars li").parent().children('li.star');
                for (i = 0; i < receiver.stars; i++) 
                {
                  $(stars[i]).addClass('star hover selected');
                }
                $('#stars').val(receiver.stars);
                $(document).ready(function()
                {
                    $("#stars li").load(function(){});
                });
                $('#rating_id').val(receiver.rating_id);
                $('#stars').val(receiver.stars);
                $('#reviewComments').val(receiver.comments);
            }
            $('.subject').val(receiver.subject);
            $('#vendors').val(receiver.id);
            $('#feedbackVendorId').val(receiver.id);
            $('#emails').val(receiver.email);
            let msg="";
            let inventor=[];
            for (i = 0; i < messages.length; i++)
            {
                $('#workstreamId').val(messages[i].wid);
                $('#feedbackWorkId').val(messages[i].wid);
                if(messages[i].Sender_id==response['flag'])
                {
                    if(messages[i].quote_status == 1)
                    {
                        $("#workquotestatusb").addClass("d-block");
                        $("#workquotestatusb").removeClass("d-none");
                        let url = "/viewquote/" + response['workid'];
                        $("#workquotestatus").attr("href", url);
                    }
                    else
                    {
                        $("#workquotestatusb").addClass("d-none");
                        $("#workquotestatusb").removeClass("d-block");
                    }
                    let now =messages[i].updated_at;
                    let date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                    let time=now.substr(11, 5);
                    console.log(date1);
                    let file =messages[i].messagefiles;
                    msg +='<div class="conversation-start"></div>';
                    
                    if(messages[i].message != null)
                    {
                        msg += '<div class="bubble me inventor">'
                       +messages[i].message+'<br>';
                    }
                    else
                    {
                        msg += '<div class="bubble me inventor">';
                    }
                    if(messages[i].messagefiles.length != 0)
                    {
                        msg +='<br>';
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url='/donwload-file/'+messages[i].messagefiles[p].id;
                            msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</i></a><br>';
                        }
                        msg +='<span class="timestamp">'+date+time+'</span></div>';
                    }
                    else
                    {
                        msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
                    }

                }
                else
                {
                    let now =messages[i].updated_at;
                    let date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                    let time=now.substr(11, 5);
                    if(messages[i].message != null)
                    {
                    msg += '<div class="bubble you vendor">'
                       +messages[i].message+'<br>';
                    }
                    else
                    {
                        msg += '<div class="bubble you vendor">';
                    }
                    if(messages[i].messagefiles.length != 0)
                    {
                        msg +='<br>';
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url='/donwload-file/'+messages[i].messagefiles[p].id;
                            msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</a><br>';
                        }
                        msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>';

                    }
                    else
                    {
                        msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
                    }
                }
            msg += "</div>";
            let title = getWorkstreamHeader(receiver.subject,receiver.companyName,stageName,receiver.name,receiver.wid);
            let sub= '<h6><b>'+receiver.subject+'</b></h6>';
            $('.subject').html(sub);
            $('.modal-title').html(title);
            $('.chat').append(msg);
            $('.quote-list').html(quotetable);
            $('#paymentdetails').modal("hide");
            $('#messageModal').modal("show");

            }
        }
    });
}

function vendorMessageRefresh(id)
{
    let i = 0;
    let p = 0;
    let j = 0;
    $.ajax(
    {
        url: '/vendor/workstream/message/' + id,
        type: 'GET',
        dataType: 'json',
        success: function(response)
        {
            let mailstatus = response['emailstatus'];
            let title = '';
            let status = response['status'];
            let stageCategory = response['category'];
            let quote = response['quote'];
            let qtstatus = response['qtstatus'];
            let quotefile = response['quotefile'];
            let quotelist = response['quotelist'];
            let quotelinelist = response['quotelinelist'];
            let quotelength = response['quotelength'];
            let ewid = response['ewid'];
            let quotetable ="";
            if(quote.length > 0)
            {
                for (i = 0; i < quotelist.length; i++)
                {
                    let url = "/vendor-quote/" + ewid;
                    let now =quotelinelist[i].updated_at;
                    let date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                    let time=now.substr(11, 5);
                    quotetable +='<h1>Quote Reference: '+quotelist[i].quoteRef_id+'</h1><b><center>Time: '+time+'</center></b>';
                    quotetable +='<table id="qid" border="2" style="float:right;width: 36%;"><tr><th>Date</th><td>'+date+'</td></tr>';
                    if(quotelist[i].quoteRef_id != null)
                    {
                    }
                    else
                    {
                        quotetable +='</table>'
                    }
                    quotetable +='<table id="qitm"><tr><th>Item</th><th>Rate</th><th>Quantity</th><th>Tax %</th><th>Price</th></tr>';
                    for (j = 0; j < quotelinelist.length;j++)
                    {
                        if(quotelinelist[j].quote_id == quotelist[i].quote_id)
                        {
                            quotetable +='<tr><td>'
                                           +quotelinelist[j].item+
                                           '</td><td>$'+
                                           +quotelinelist[j].rate+
                                           '</td><td>'+
                                           +quotelinelist[j].quantity+
                                           '</td><td>'+
                                           +quotelinelist[j].tax+
                                           '</td><td>$'+
                                           +quotelinelist[j].price+
                                           '</td></tr>';
                        }
                    }
                    quotetable +='</table>';
                    quotetable +='<table id="qid" border="2" style="float:right;width: 36%;">';
                    if(quotelist[i].extra != null)
                    {
                        quotetable +='<tr><th>Extra</th><td>$'+quotelist[i].extra+'</td></tr>';
                    }
                    if(quotelist[i].discount != null)
                    {
                        quotetable +='<tr><th>Discount</th><td>$'+quotelist[i].discount+'</td></tr>';
                    }
                    quotetable +='<tr><th>Total Amount</th><td>$'+quotelist[i].finalprice+'</td></tr></table><br>';
                    quotetable +='<a href="'+ url +'" class="sign " target="blank">Quote Details</a>';
                }
                if(quotefile.length > 0)
                {
                    quotetable +='<br><br><b>Attachment</b>'
                    for (i = 0; i < quotefile.length; i++)
                    {
                        let furl = "/quote/donwloadfile/" + quotefile[i].quoteFile_id;
                        quotetable +='<a href="'+ furl +'" target="_blank"><br>'+quotefile[i].fileName+'</a>';
                    }
                }
                $("#nolink").addClass("d-none");
                $("#nolink").removeClass("d-block");
                $(".quote-list").addClass("d-block");
                $(".quote-list").removeClass("d-none");
                let url = "/viewquote/" + response['workid'];
                let eurl = "/editquote/" + response['workid'];
                $("#editquote").attr("href", eurl);
                $("#linkquote").attr("href", url);
                if(qtstatus.quote_status == 'Accepted')
                {
                    $(".qedit").addClass("d-none");
                    $(".qedit").removeClass("d-block");
                }
                else
                {
                    $(".qedit").removeClass("d-none");
                    $(".qedit").addClass("d-block");
                }
                $(".qsubmit").addClass("d-none");
                $(".qsubmit").removeClass("d-block");
            }
            else
            {
                $(".qsubmit").addClass("d-block");
                $(".qedit").addClass("d-none");
                $("#qlink").addClass("d-none");
                $("#qlink").removeClass("d-block");
                $("#nolink").addClass("d-block");
                $(".qsubmit").removeClass("d-none");
                $(".qedit").removeClass("d-block");
                $("#qlink").removeClass("d-block");
                $("#nolink").removeClass("d-none");
            }
            if(status.workstreamStatus == 1)
            {
                $("#workopen").addClass("d-block");
                $("#workopen").removeClass("d-none");
                $("#write").addClass("d-none");
                $("#write").removeClass("d-block");
                $(".qedit").addClass("d-none");
                $(".qedit").removeClass("d-block");
                $("#workstatus").addClass("d-block");
                $("#workstatus").removeClass("d-none");
            }
            else
            {
                $("#write").addClass("d-block");
                $("#workopen").addClass("d-none");
                $("#workstatus").addClass("d-none");
                $("#write").removeClass("d-none");
                $("#workopen").removeClass("d-block");
                $("#workstatus").removeClass("d-block");
            }
            let work = response['work'];
            let receiver = response['receiver'];
            let messages = response['messages'];
            let name = receiver.name;
            let anonymous = response.anonymous;
            $('.reciver-name').html(receiver.name);
            $('#subject').val(receiver.subject);
            $('#vendors').val(receiver.id);
            $('#emails').val(receiver.email);
            let url1 = "/quote/" + response['workid'];
            $("#Quote").attr("href", url1);
            let msg="";
            let inventor=[];
            for (i = 0; i < messages.length; i++)
            {
                $('.datetime').html(messages[i].updated_at);
                let now =messages[i].updated_at;
                let date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                let date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                let time=now.substr(11, 5);
                $('#workstreamId').val(messages[i].wid);
                let file =messages[i].messagefiles;
                if(messages[i].Sender_id==response['flag'])
                {
                    let now =messages[i].updated_at;
                    let date1=new Date(now).toDateString('dd-MMM-yyyy').split(' ');
                    let date=date1[0]+', '+date1[1]+' '+date1[2]+', '+date1[3];
                    let time=now.substr(11, 5);
                    let file =messages[i].messagefiles;
                    msg +='<div class="conversation-start"></div>';
                    if(messages[i].message != null)
                    {
                    msg += '<div class="bubble me inventor">'
                        +messages[i].message+'<br>';
                    }
                    else
                    {
                        msg += '<div class="bubble me inventor">';
                    }
                    if(messages[i].messagefiles.length != 0)
                    {
                        msg +='<br>';
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url='/donwload-file/'+messages[i].messagefiles[p].id;
                            msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</i></a><br>';
                        }
                        msg +='<span class="timestamp">'+date+time+'</span></div>';
                    }
                    else
                    {
                        msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
                    }
                }
                else
                {
                    if(messages[i].message != null)
                    {
                    msg += '<div class="bubble you vendor">'
                        +messages[i].message+'<br>';
                    }
                    else
                    {
                        msg += '<div class="bubble you vendor">';
                    }
                    if(messages[i].messagefiles.length != 0)
                    {
                        msg +='<br>';
                        for (p = 0; p < messages[i].messagefiles.length; p++)
                        {
                            let url='/donwload-file/'+messages[i].messagefiles[p].id;
                             msg +='<a href="'+url+'"><span class="attachlink"></span><i>'+messages[i].messagefiles[p].fileName+'</i></a><br>';
                        }
                        msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>';

                    }
                    else
                    {
                        msg +='<span class="timestamp">'+date+'&nbsp;'+time+'</span></div>'
                    }
                }
                msg += "</div>";
                if(anonymous == 1)
                {
                    let title='<span class="name reciver-name"><h1><center>'
                         +'Inventor'+
                         '</center></h1>'+stageCategory.stageName+'</span><br><span class="pull-right"><h5>WId:'+receiver.wid+'</h5></span>'
                         ;
                }
                else
                {
                    let title='<span class="name reciver-name"><h3><center>'
                         + receiver.name+ 
                         '</center></h3>'+stageCategory.stageName+'</span><br><span class="pull-right"><h6>Communication Id:'+receiver.wid+'</h6></span>'
                         ;
                }
                let mailst = '';
                if(mailstatus.vendorEmailNotification == 'No')
                {
                    mailst += '<label for="test" id="emailnotification"><input type="checkbox" class="emailnotification" id="test" value="" data-id="'+receiver.wid+'" id="emailnotification" name="emailnotification" checked><span class="emailchange emailchecked"><small></small></span>Notifications</label>';
                }
                if(mailstatus.vendorEmailNotification == 'Yes')
                {

                    mailst += '<label for="test" id="emailnotification"><input type="checkbox" class="emailnotification" id="test" value="" data-id="'+receiver.wid+'" id="emailnotification" name="emailnotification" ><span class="defaultemail emailchecked"><small></small></span>Notifications</label>';
                     
                }
                mailst += ' <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Email Notification on/off Information"><button class="btn" style="pointer-events: none;" type="button" disabled><i class="fa fa-info-circle fa_custom fa-2x "></i></button></span>';
                let sub= '<h6><b>'+receiver.subject+'</b></h6>';
                $('.subject').html(sub);
                $('.switcher').html(mailst);
                $('.modal-title').html(title);
                $('.chat').append(msg);
                $('.quote-list').html(quotetable);
                $('#messageModal').modal("show");
                $('#overlay').fadeOut("300");
            }
        }
     });
}
